// removed by extract-text-webpack-plugin
module.exports = {"container":"general__container___njUoC overflow-hidden","circularTransition":"general__circularTransition___2qag7 transitionDuration-xxl transitionTimingFunction-cv-easeOutCircular","contentHidden":"general__contentHidden___2s3Vs display-block opacity-0 transitionDelay-m","iconWrap":"general__iconWrap___5Wcl8 fill-white pinCenter position-absolute","icon":"general__icon___2TuL8 transitionDuration-xxl transitionProperty-all transitionTimingFunction-cb--scaleUp","iconHidden":"general__iconHidden___cY1gL","iconShown":"general__iconShown___1WINM transitionDelay-xl"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/StateWrapper/style/general.css
// module id = 105
// module chunks = 0 2